// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo_pageContainer__YUVHk {
  min-height: 100vh;
  background-color: #1F1D1D;
  padding: 5rem 1rem;
  font-family: 'Manrope', sans-serif;
  color: #ffffff;
}

.Logo_contentWrapper__sZD14 {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 2rem;
}

/* Updated header container:
   Title on the left, Back on the right, 
   with a bottom border line for visual separation */
.Logo_headerContainer__Xl3EV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  border-bottom: 1px solid #3A3A3A;
  padding-bottom: 1rem;
}

.Logo_pageTitle__mBDJe {
  margin: 0; /* Remove default margin to align with back button */
  font-size: 2.5rem;
  font-weight: 700;
}

.Logo_backButton__O\\+PNW {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  color: #ffffff;
  border: none;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
}

.Logo_backButton__O\\+PNW:hover {
  background-color: rgba(229, 0, 0, 0.1); /* #E50000 at 10% opacity */
}

.Logo_backIcon__ZJqox {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}

/* Notification messages */
.Logo_notification__cUKzo {
  background-color: #2ECC71; /* success background */
  color: #ffffff;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 500;
}

.Logo_error__qgGAc {
  background-color: #E50000;
}

.Logo_logoGrid__KRpbB {
  display: grid;
  gap: 2rem;
  margin-bottom: 2rem;
}

/* Two-column layout for medium and up screens */
@media (min-width: 768px) {
  .Logo_logoGrid__KRpbB {
    grid-template-columns: repeat(2, 1fr);
  }
}

.Logo_logoCard__MtzMn {
  background-color: #2B2B2B;
  border-radius: 1rem;
  border: 1px solid #3A3A3A;
  overflow: hidden;
}

.Logo_cardHeader__lNgPI {
  padding: 1.5rem;
  background-color: #1F1D1D;
  border-bottom: 2px solid #E50000;
}

.Logo_cardTitle__RiUps {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.Logo_cardContent__RGYQ8 {
  padding: 1.5rem;
}

.Logo_label__6Xa3I {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.Logo_currentLogo__obLES,
.Logo_previewSection__AzG5T {
  margin-bottom: 1.5rem;
}

.Logo_imageWrapper__GJl7s {
  background-color: #3A3A3A;
  padding: 1.5rem;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Logo_logoImage__yPT7H {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
}

.Logo_uploadSection__KOauj {
  display: flex;
  justify-content: center;
}

.Logo_uploadLabel__b9X16 {
  cursor: pointer;
}

.Logo_fileInput__G8hzk {
  display: none;
}

.Logo_uploadButton__1TSdE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #E50000;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
}

.Logo_uploadButton__1TSdE:hover {
  background-color: #c00000;
}

.Logo_uploadIcon__PbSgm {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}

.Logo_saveContainer__T62qI {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.Logo_saveButton__kxbHa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #E50000;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 1rem;
  font-weight: 600;
}

.Logo_saveButton__kxbHa:hover {
  background-color: #c00000;
}

.Logo_saveButton__kxbHa:disabled {
  background-color: #6b6b6b;
  cursor: not-allowed;
}

.Logo_saveIcon__dhLTW {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .Logo_pageContainer__YUVHk {
    padding: 1rem 0.5rem;
  }

  .Logo_pageTitle__mBDJe {
    font-size: 2rem;
  }

  .Logo_cardHeader__lNgPI {
    padding: 1rem;
  }

  .Logo_cardContent__RGYQ8 {
    padding: 1rem;
  }

  .Logo_uploadButton__1TSdE {
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .Logo_pageContainer__YUVHk {
    padding: 0.5rem;
  }

  .Logo_contentWrapper__sZD14 {
    padding-top: 1rem;
  }

  .Logo_pageTitle__mBDJe {
    font-size: 1.75rem;
  }

  .Logo_cardHeader__lNgPI,
  .Logo_cardContent__RGYQ8 {
    padding: 0.75rem;
  }

  .Logo_uploadButton__1TSdE,
  .Logo_saveButton__kxbHa {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .Logo_logoGrid__KRpbB {
    gap: 1rem;
  }

  .Logo_backButton__O\\+PNW {
    padding: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/Logo.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS,EAAE,oDAAoD;EAC/D,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC,EAAE,2BAA2B;AACrE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap');\n\n.pageContainer {\n  min-height: 100vh;\n  background-color: #1F1D1D;\n  padding: 5rem 1rem;\n  font-family: 'Manrope', sans-serif;\n  color: #ffffff;\n}\n\n.contentWrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-top: 2rem;\n}\n\n/* Updated header container:\n   Title on the left, Back on the right, \n   with a bottom border line for visual separation */\n.headerContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #3A3A3A;\n  padding-bottom: 1rem;\n}\n\n.pageTitle {\n  margin: 0; /* Remove default margin to align with back button */\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  background-color: transparent;\n  color: #ffffff;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n}\n\n.backButton:hover {\n  background-color: rgba(229, 0, 0, 0.1); /* #E50000 at 10% opacity */\n}\n\n.backIcon {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.5rem;\n}\n\n/* Notification messages */\n.notification {\n  background-color: #2ECC71; /* success background */\n  color: #ffffff;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.error {\n  background-color: #E50000;\n}\n\n.logoGrid {\n  display: grid;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n/* Two-column layout for medium and up screens */\n@media (min-width: 768px) {\n  .logoGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.logoCard {\n  background-color: #2B2B2B;\n  border-radius: 1rem;\n  border: 1px solid #3A3A3A;\n  overflow: hidden;\n}\n\n.cardHeader {\n  padding: 1.5rem;\n  background-color: #1F1D1D;\n  border-bottom: 2px solid #E50000;\n}\n\n.cardTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.cardContent {\n  padding: 1.5rem;\n}\n\n.label {\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.currentLogo,\n.previewSection {\n  margin-bottom: 1.5rem;\n}\n\n.imageWrapper {\n  background-color: #3A3A3A;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoImage {\n  max-width: 100%;\n  max-height: 100px;\n  object-fit: contain;\n}\n\n.uploadSection {\n  display: flex;\n  justify-content: center;\n}\n\n.uploadLabel {\n  cursor: pointer;\n}\n\n.fileInput {\n  display: none;\n}\n\n.uploadButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #E50000;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n}\n\n.uploadButton:hover {\n  background-color: #c00000;\n}\n\n.uploadIcon {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.5rem;\n}\n\n.saveContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n.saveButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #E50000;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.saveButton:hover {\n  background-color: #c00000;\n}\n\n.saveButton:disabled {\n  background-color: #6b6b6b;\n  cursor: not-allowed;\n}\n\n.saveIcon {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .pageContainer {\n    padding: 1rem 0.5rem;\n  }\n\n  .pageTitle {\n    font-size: 2rem;\n  }\n\n  .cardHeader {\n    padding: 1rem;\n  }\n\n  .cardContent {\n    padding: 1rem;\n  }\n\n  .uploadButton {\n    padding: 0.5rem 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .pageContainer {\n    padding: 0.5rem;\n  }\n\n  .contentWrapper {\n    padding-top: 1rem;\n  }\n\n  .pageTitle {\n    font-size: 1.75rem;\n  }\n\n  .cardHeader,\n  .cardContent {\n    padding: 0.75rem;\n  }\n\n  .uploadButton,\n  .saveButton {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .logoGrid {\n    gap: 1rem;\n  }\n\n  .backButton {\n    padding: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Logo_pageContainer__YUVHk`,
	"contentWrapper": `Logo_contentWrapper__sZD14`,
	"headerContainer": `Logo_headerContainer__Xl3EV`,
	"pageTitle": `Logo_pageTitle__mBDJe`,
	"backButton": `Logo_backButton__O+PNW`,
	"backIcon": `Logo_backIcon__ZJqox`,
	"notification": `Logo_notification__cUKzo`,
	"error": `Logo_error__qgGAc`,
	"logoGrid": `Logo_logoGrid__KRpbB`,
	"logoCard": `Logo_logoCard__MtzMn`,
	"cardHeader": `Logo_cardHeader__lNgPI`,
	"cardTitle": `Logo_cardTitle__RiUps`,
	"cardContent": `Logo_cardContent__RGYQ8`,
	"label": `Logo_label__6Xa3I`,
	"currentLogo": `Logo_currentLogo__obLES`,
	"previewSection": `Logo_previewSection__AzG5T`,
	"imageWrapper": `Logo_imageWrapper__GJl7s`,
	"logoImage": `Logo_logoImage__yPT7H`,
	"uploadSection": `Logo_uploadSection__KOauj`,
	"uploadLabel": `Logo_uploadLabel__b9X16`,
	"fileInput": `Logo_fileInput__G8hzk`,
	"uploadButton": `Logo_uploadButton__1TSdE`,
	"uploadIcon": `Logo_uploadIcon__PbSgm`,
	"saveContainer": `Logo_saveContainer__T62qI`,
	"saveButton": `Logo_saveButton__kxbHa`,
	"saveIcon": `Logo_saveIcon__dhLTW`
};
export default ___CSS_LOADER_EXPORT___;
